module.exports = __webpack_public_path__ + "static/media/1.92bed9c7.jpg";